import { render, staticRenderFns } from "./bank-order.vue?vue&type=template&id=3a63e83a&"
import script from "./bank-order.vue?vue&type=script&lang=js&"
export * from "./bank-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports